const loadFonts = () => {
  const pablicPath = process.env.REACT_APP_ASSET_PATH || '/';

  const fontInterRegular = new FontFace('Inter', `url('${pablicPath}fonts/Inter-Regular.ttf') format('truetype')`, {
    weight: 'normal',
    style: 'normal',
  });

  const fontInterBold = new FontFace('Inter-bold', `url('${pablicPath}fonts/Inter-Bold.ttf') format('truetype')`, {
    weight: 'bold',
    style: 'normal',
  });

  const fontInterBlack = new FontFace('Inter-Black', `url('${pablicPath}fonts/Inter-Black.ttf') format('truetype')`, {
    weight: '900',
    style: 'normal',
  });

  const fontCasinoTournament = new FontFace('casino-tournament', [
    `url('${pablicPath}fonts/icons/casino-tournament.eot?ppwsok') format('embedded-opentype')`,
    `url('${pablicPath}fonts/icons/casino-tournament.ttf?ppwsok') format('truetype')`,
    `url('${pablicPath}fonts/icons/casino-tournament.woff?ppwsok') format('woff')`,
    `url('${pablicPath}fonts/icons/casino-tournament.svg?ppwsok#casino-tournament') format('svg')`
  ].join(', '), {
    weight: 'normal',
    style: 'normal',
    display: 'block'
  });

  fontInterRegular.load().then((font) => {
    document.fonts.add(font);
  });

  fontInterBold.load().then((font) => {
    document.fonts.add(font);
  });

  fontInterBlack.load().then((font) => {
    document.fonts.add(font);
  });

  fontCasinoTournament.load().then((font) => {
    document.fonts.add(font);
  });
};

export default loadFonts;
